var a = Object.defineProperty;
var o = (n, e, t) => e in n ? a(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var i = (n, e, t) => o(n, typeof e != "symbol" ? e + "" : e, t);
import c from "axios";
class u {
  constructor() {
    i(this, "instance");
    // @ts-ignore - used in setAuthToken method
    i(this, "authToken", null);
    this.instance = c.create({
      timeout: 3e4
    }), this.setupInterceptors();
  }
  configure(e) {
    this.instance.defaults.baseURL = e.baseURL, e.timeout && (this.instance.defaults.timeout = e.timeout), e.headers && Object.entries(e.headers).forEach(([t, s]) => {
      this.instance.defaults.headers.common[t] = s;
    });
  }
  setAuthToken(e) {
    this.authToken = e, e ? this.instance.defaults.headers.common.Authorization = `Bearer ${e}` : (delete this.instance.defaults.headers.common.Authorization, typeof localStorage < "u" && localStorage.removeItem("accessToken"));
  }
  setupInterceptors() {
    this.instance.interceptors.request.use(
      (e) => e,
      (e) => Promise.reject(e)
    ), this.instance.interceptors.response.use(
      (e) => e,
      (e) => {
        var t;
        return ((t = e.response) == null ? void 0 : t.status) === 401 && (this.setAuthToken(null), console.error("Unauthorized - token cleared")), Promise.reject(e);
      }
    );
  }
  /**
   * Get axios instance
   */
  getInstance() {
    return this.instance;
  }
  async get(e, t) {
    return this.instance.get(e, t);
  }
  async post(e, t, s) {
    const r = {
      maxContentLength: 10485760
    };
    return this.instance.post(e, t, { ...r, ...s });
  }
  async put(e, t, s) {
    return this.instance.put(e, t, s);
  }
  async patch(e, t, s) {
    return this.instance.patch(e, t, s);
  }
  async delete(e, t) {
    return this.instance.delete(e, t);
  }
}
const p = new u();
class d {
  constructor() {
    i(this, "endpoint", "");
  }
  getEndpoint(e = "") {
    return e ? `${this.endpoint}/${e}` : this.endpoint;
  }
}
export {
  d as HttpClient,
  p as httpClient
};
